import { DateTime } from "luxon"
import moment, { Moment } from "moment"

export function toMoment(date: DateTime): Moment | null {
  if (!date) {
    return null
  } else {
    return moment.parseZone(date.toISO())
  }
}

function parseDateTime(dateStr?: string, timezone?: string, options?: { asMoment?: false }): DateTime | null
function parseDateTime(dateStr?: string, timezone?: string, options?: { asMoment: true }): Moment | null

function parseDateTime(
  dateStr?: string,
  timezone?: string,
  options: { asMoment?: boolean } = {},
): DateTime | Moment | null {
  if (!dateStr) {
    return null
  }

  let date: DateTime

  if (timezone) {
    date = DateTime.fromISO(dateStr, { zone: timezone })
  } else {
    date = DateTime.fromISO(dateStr)
  }

  if (!date.isValid) {
    date = DateTime.fromFormat(dateStr, "yyyy-MM-dd HH:mm:ss z")

    if (timezone) {
      date = date.setZone(timezone)
    }
  }

  if (options.asMoment) {
    return toMoment(date)
  } else {
    return date
  }
}

export default parseDateTime
